import { MtnaDataType } from '@mtna/data-core-ui';

export class RdsDataTypeUtil {
  /**
   * Determine if a `MtnaDataType` is numeric.
   * @param type Data type to test
   * @returns Whether the type is numeric
   */
  static isMtnaDataTypeNumeric(type: MtnaDataType): boolean {
    switch (type) {
      case 'BYTE':
      case 'SHORT':
      case 'INTEGER':
      case 'LONG':
      case 'FLOAT':
      case 'DOUBLE':
      case 'NUMERIC':
      case 'BIG_INTEGER':
      case 'BIG_DECIMAL':
        return true;
      default:
        return false;
    }
  }

  /**
   * Determine if a `MtnaDataType` is text.
   * @param type Data type to test
   * @returns Whether the type is text
   */
  static isMtnaDataTypeText(type: MtnaDataType): boolean {
    switch (type) {
      case 'BYTE_ARRAY':
      case 'CHAR':
      case 'TEXT':
      case 'LONG_TEXT':
        return true;
      default:
        return false;
    }
  }
  /**
   * Simplfy `MtnaDataType`.
   * @param type Data type to simplify
   * @returns Whether the type is `'DATE' | 'NUMERIC' | 'TEXT'`
   */
  static simplifyMtnaDataType(type: MtnaDataType): Extract<MtnaDataType, 'DATE' | 'NUMERIC' | 'TEXT'> {
    switch (type) {
      case 'BYTE_ARRAY':
      case 'CHAR':
      case 'TEXT':
      case 'LONG_TEXT':
        return 'TEXT';
      case 'BYTE':
      case 'SHORT':
      case 'INTEGER':
      case 'LONG':
      case 'FLOAT':
      case 'DOUBLE':
      case 'NUMERIC':
      case 'BIG_INTEGER':
      case 'BIG_DECIMAL':
        return 'NUMERIC';
      case 'DATE':
      case 'TIME':
      case 'TIMESTAMP':
        return 'DATE';
    }
  }
}
